import React, { Component } from 'react';
import { withRouter } from '../../../../common/utils/NavigationWrapper';

import { Map as MapIcon } from '@mui/icons-material';

import { Button } from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';
import RegionsManager from './RegionsManager';
import GroupsManagerContainer from '../GroupsManager/GroupsManagerContainer';
import {
  getRegions,
  getRegion,
  saveRegion,
  deleteRegion,
  getGroupsByRegion,
} from './RegionsManager.actions';
import Validators from '../../../../common/utils/Validators';
import Store from '../../../../redux/Store';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';
import Constants from '../../../../common/constants/Constants';
import Loading from '../../../../common/components/Loading/Loading';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';
import './RegionsManager.css';

class RegionsManagerContainer extends Component {
  constructor() {
    super();

    this.state = {
      regionList: [],
      selectedRegionId: null,
      regionToBeAdded: {},
      region: {},
      showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
      errorMessageRegionName: '',
      errorMessageNewRegionName: '',
      isFetching: true,
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
        disableMainAction: false,
      },
      messageToConfirm: '',
      groups: [],
      isFetchingGroups: false,
    };
  }

  componentDidMount() {
    const { params } = this.props;
    let regionList = '';

    getRegions()
      .then((res) => {
        regionList = res.body;
        if (params.id) {
          return getRegion(parseInt(params.id, 10));
        }
        return null;
      })
      .then((resp) => {
        if (resp === null) {
          this.setState({
            regionList,
            errorMessageRegionName: '',
            isFetching: false,
          });

          if (regionList.length > 0) {
            this._onRegionRowSelected(regionList[0]);
          }
        } else {
          this.setState({
            regionList,
            region: resp.body,
            selectedRegionId: parseInt(params.id, 10),
            errorMessageRegionName: '',
            isFetching: false,
          });
        }
      });
  }

  componentWillReceiveProps(props) {
    const { params } = props;
    if (params.id) {
      getRegion(parseInt(params.id, 10)).then((res) => {
        this.setState({
          selectedRegionId: parseInt(params.id, 10),
          region: res.body,
        });
      });
    }
  }

  render() {
    return (
      <Loading condition={this.state.isFetching}>
        <div className="u-fx regions-manager__container">
          <div className="u-fx-align-items regions-manager__left">
            <Tile
              title="Regions"
              TitleIcon={MapIcon}
              helpTag="regions_and_groups-regions"
              RightContent={
                <div>
                  <PermissionsCheck permission={PermissionsEnum.EDIT_REGIONS}>
                    <Button
                      variant="contained"
                      data-qa="qa-addNewRegion"
                      className="u-ml-double"
                      color="primary"
                      onClick={() => this._openAddRegionDialogCallback('')}
                    >
                      Add region
                    </Button>
                  </PermissionsCheck>
                </div>
              }
            >
              <RegionsManager
                regionList={this.state.regionList}
                selectedRegionId={this.state.selectedRegionId}
                onChangeCallback={this._onChangeNewRegion}
                showDialog={this.state.showDialog}
                addCallback={this._openAddRegionDialogCallback}
                errorRegionName={this.state.errorMessageNewRegionName}
                regionName={this.state.region ? this.state.regionToBeAdded.Name : ''}
                isFetching={this.state.isFetching}
                onDeleteCallback={this._onDeleteRegion}
                onEditCallback={this._onEditRegion}
                onRegionRowSelected={this._onRegionRowSelected}
                showConfirmDialog={this.state.showConfirmDialog}
                messageToConfirm={this.state.messageToConfirm}
              />
            </Tile>
          </div>
          <div className="u-fx-align-items regions-manager__right">
            {this.state.selectedRegionId && this.state.region ? (
              <Loading condition={this.state.isFetchingGroups}>
                <PermissionsCheck permission={PermissionsEnum.VIEW_GROUPS}>
                  <GroupsManagerContainer region={this.state.region} groups={this.state.groups} />
                </PermissionsCheck>
              </Loading>
            ) : null}
          </div>
        </div>
      </Loading>
    );
  }

  _onRegionRowSelected = (selectedRegion) => {
    const { navigate } = this.props;
    navigate(`/regions-and-groups/${selectedRegion.RegionId}`);
    this.setState({ isFetchingGroups: true });
    let groups = null;

    getGroupsByRegion(selectedRegion.RegionId)
      .then((res) => {
        groups = res.body;
        this.setState({
          groups,
          isFetchingGroups: false,
        });
      })
      .catch((err) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message:
              err.response.body.Message && err.response && err.response.body.error_description
                ? err.response.body.error_description
                : Constants.DEFAULT_ERROR_MESSAGE,
          })
        );
      });
  };

  _onChangeNewRegion = (propertyName, value) => {
    let region = {
      ...Object.assign({}, this.state.regionToBeAdded),
      [propertyName]: value,
    };
    this.setState((prevState) => ({
      regionToBeAdded: region,
      errorMessageNewRegionName:
        prevState.regionToBeAdded.Name !== region.Name
          ? this._getValidationErrorMessage(value)
          : prevState.errorMessageNewRegionName,
    }));
  };

  _onDeleteRegion = (event, regionToDelete) => {
    event.stopPropagation();
    this.setState({
      messageToConfirm: `Are you sure you want to delete region "${regionToDelete.Name}"?`,
      showConfirmDialog: {
        title: `Delete region ${regionToDelete.Name}`,
        show: true,
        action: () => this._onConfirmDeleteRegion(regionToDelete),
        cancel: this._onCancelDeleteRegion,
        mainActionLabel: 'Yes',
      },
    });
  };

  _onConfirmDeleteRegion = (regionToDelete) => {
    let emptyRegion = {};
    if (regionToDelete) {
      this.setState({ showConfirmDialog: { disableMainAction: true } });

      deleteRegion(regionToDelete.RegionId)
        .then(() => getRegions())
        .then((resp) => {
          this.setState({
            regionList: resp.body,
            messageToConfirm: '',
            showConfirmDialog: {
              show: false,
              disableMainAction: false,
              action: () => {},
              cancel: () => {},
            },
          });

          if (resp.body.length > 0) {
            this._onRegionRowSelected(resp.body[0]);
          } else {
            this.setState({}, () => this.props.navigate(`/regions-and-groups`));
          }
        })
        .then(() => {
          this._showSuccesMessage('Successfully deleted.');
        })
        .catch((err) => this._showFailMessage('Error occured'));
    }
  };

  _onCancelDeleteRegion = () => {
    this.setState({
      messageToConfirm: '',
      showConfirmDialog: {
        show: false,
        action: () => {},
        cancel: () => {},
      },
    });
  };

  _onEditRegion = (event, regionToEdit) => {
    const { navigate } = this.props;
    navigate(`/region-details/${regionToEdit.RegionId}`);
    event.stopPropagation();
  };

  _addRegion = () => {
    if (
      this.state.regionToBeAdded.Name &&
      !this._existingRegionValidation(this.state.regionToBeAdded.Name)
    ) {
      this.setState({ isFetching: true }, () =>
        saveRegion(this.state.regionToBeAdded)
          .then(() => getRegions())
          .then((res) => {
            this.setState(
              {
                regionList: res.body,
                showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
                isFetching: false,
              },
              () => this._showSuccesMessage('Successfully added.')
            );
          })
          .catch((err) => {
            this.setState({ isFetching: true });
            this._showFailMessage('Error occured');
          })
      );
    } else {
      this._showFailMessage('Empty region name or similar region name already exists!');
    }
  };

  _cancelCreatingRegion = () => {
    this.setState({
      showDialog: { show: false, title: '', action: () => {}, cancel: () => {} },
      regionToBeAdded: {},
      errorMessageNewRegionName: '',
    });
  };

  _openAddRegionDialogCallback = () => {
    this.setState({
      showDialog: {
        show: true,
        title: 'Add a new region',
        action: this._addRegion,
        cancel: this._cancelCreatingRegion,
      },
    });
  };

  _getValidationErrorMessage = (value) => {
    let validationMessage = '';
    if (!Validators.validateStringBetweenRange(value, 1, 200)) {
      validationMessage =
        'Enter an alphanumeric value between 1 and 200 characters; for example: Region 01';
    }
    return validationMessage;
  };

  _existingRegionValidation = (value) => {
    for (let region of this.state.regionList) {
      if (value.toLowerCase().replace(/\s/g, '') === region.Name.toLowerCase().replace(/\s/g, '')) {
        return true;
      }
    }
  };

  _showSuccesMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
        message: theMessage,
      })
    );
  }

  _showFailMessage(theMessage) {
    Store.dispatch(
      showSnackbar({
        type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
        message: theMessage,
      })
    );
  }
}

export default withRouter(RegionsManagerContainer);
